import { VirtualItem } from "@tanstack/react-virtual";
import shallow from "zustand/shallow";

export const equalRows = (rowsA: VirtualItem[], rowsB: VirtualItem[]) => {
	if (rowsA.length !== rowsB.length) {
		return false;
	}
	return rowsA.every((item, i) => shallow(item, rowsB[i]));
};
